import React from 'react';
import WeatherIconsContainer from '../../Componant/Icons/WeatherIcon';

const WeatherIcons = () => {
  return (
    <div className='page-body'>
      <WeatherIconsContainer />
    </div>
  );
};

export default WeatherIcons;
